module.exports = __webpack_public_path__ + "static/media/Hair_3_grey.607e9850.svg";